import { useEffect } from "react";

import Seo from "../../components/Seo";
import PublicBreadcrumb from "../../components/PublicBreadcrumb";
import { seoFromPublicPage } from "../../seo/publicPages";
import LandingFooter from "../LandingPage/LandingFooter";
import LandingGuidesSection from "../LandingPage/LandingGuidesSection";
import LandingNavbar from "../LandingPage/LandingNavbar";
import "../LandingPage/LandingPage.css";
import "../../components/PublicBreadcrumb.css";

const LANDING_CHROME_COLOR = "#2a2544";

export default function GhiduriPage() {
  useEffect(() => {
    const themeMeta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    const previousTheme = themeMeta?.getAttribute("content");
    const previousScheme = document.documentElement.style.colorScheme;
    themeMeta?.setAttribute("content", LANDING_CHROME_COLOR);
    document.documentElement.style.colorScheme = "dark";
    return () => {
      if (previousTheme) themeMeta?.setAttribute("content", previousTheme);
      document.documentElement.style.colorScheme = previousScheme;
    };
  }, []);

  return (
    <div className="landing-page">
      <Seo {...seoFromPublicPage("/ghiduri")} />

      <div className="landing-page__glow landing-page__glow--left" aria-hidden="true" />
      <div className="landing-page__glow landing-page__glow--right" aria-hidden="true" />

      <LandingNavbar />

      <main>
        <div className="landing-shell public-breadcrumb-shell">
          <PublicBreadcrumb path="/ghiduri" />
        </div>
        <LandingGuidesSection titleAs="h1" />
      </main>

      <LandingFooter />
    </div>
  );
}
